import { createAction, props } from '@ngrx/store';

export const Set2FactorAuthToken = createAction(
    '[2FA] Save 2FA Token',
    props<{ twoFactorAuthToken: string }>(),
);

export const SetCodeToken = createAction(
    '[2FA] Save Pincode Token',
    props<{ codeToken: string }>(),
);

export const SetPhone = createAction(
    '[2FA] Save Phone',
    props<{ phone: string }>(),
);
